import { PrimaryButton } from "@fluentui/react/lib/Button";
import React from "react";
import { Icon } from "@fluentui/react/lib/Icon";

interface Props {
  text: string;
  disabled?: boolean;
  checked?: boolean;
  onClick?: () => any;
  baseTypeProps?: any;
}

const AddButton = (props: Props) => {
  return (
    <>
      <PrimaryButton
        text={props.text}
        onClick={props.onClick}
        disabled={props.disabled}
        checked={props.checked}
        {...props.baseTypeProps}
      >
        <Icon iconName="Add" />
      </PrimaryButton>
    </>
  );
};

export default AddButton;
